import styled from 'styled-components';

import { COLORS, ANIM } from '../../../../theme/tokens';

/* Segmented device toggle (desktop / tablet / mobile) shown centred in the preview header. Mirrors the
   configurator's DeviceSwitcher, on the standard studio tokens. The active segment reads as a raised,
   rounded pill inside the track. */

export const Switch = styled.div<{ $touch: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  background: ${COLORS.surfaceFaint};
  border: 1px solid ${COLORS.hairline};
  /* Touch: as tall as a Button (the app's 48px control height). */
  ${({ $touch }) => ($touch ? 'box-sizing: border-box; height: 48px;' : '')}
`;

export const Option = styled.button<{ $active: boolean; $touch: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Touch: a 48px wide tap target filling the track's height. */
  width: ${({ $touch }) => ($touch ? '48px' : '36px')};
  height: ${({ $touch }) => ($touch ? '100%' : '26px')};
  padding: 0;
  border: 0;
  border-radius: 999px;
  cursor: pointer;
  color: ${({ $active }) => ($active ? COLORS.text : COLORS.textSubtle)};
  background: ${({ $active }) => ($active ? COLORS.surfaceCard : 'transparent')};
  box-shadow: ${({ $active }) => ($active ? `0 1px 3px -1px ${COLORS.pageBg}` : 'none')};
  transition:
    color ${ANIM.INTERACT_MS}ms ${ANIM.EASE},
    background-color ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  &:hover {
    color: ${COLORS.text};
  }

  svg {
    display: block;
  }
`;
